import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class HatcheriesStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
